import { Schema } from "effect";

export const BrowserNotification = Schema.Struct({
  _tag: Schema.Literal("browserNotification"),
  notificationId: Schema.String,
  taskId: Schema.String,
  title: Schema.String,
  body: Schema.String,
  route: Schema.String,
  tag: Schema.String,
  requireInteraction: Schema.Boolean,
});
export type BrowserNotification = typeof BrowserNotification.Type;

export const UserNotification = Schema.Union(BrowserNotification);
export type UserNotification = typeof UserNotification.Type;
